import { Constants } from '@src/app/commons/Constants';
import { DEBUG } from '@src/DEBUG';
import { XsBaseClass } from '../controllers/base.class';
DEBUG.open ( '/xs/utilities/ranger' );

/*
  Ranger handles a quick way to check if values falls within certain ranges
*/

export class XsRanger extends XsBaseClass {

  debugId:string = 'RANGER';

  // our test of ranges
  tests:any = [];

  // minimum value (don't need max for this)
  min:number = null;

  constructor ( config:any = {}) {
    super(config);
    // console.log( this.debugId + ' :: CONSTRUCTOR');
    DEBUG.log ( '/xs/utilities/ranger' );

    // start checking
    if ( this._config.ranges && this._config.ranges.length ) {
      this.setup( this._config.ranges );
    }
  }

  check ( n:number ) {
    for ( let test=0; test < this.tests.length; test++ ) {
      if ( n < this.tests[test] ) {
        return test - 1;
      }
    }
    return this.tests.length-1;
  }

  setup ( ranges ) {
    if ( ranges && ranges.length ) {
      this.tests = ranges;

      // this.min = Math.min(...ranges);
      // [12,45,78,198]
      // console.log('!!!RANGER', this.min, this.tests, [-1,0,1,2,2,3,3], this.check(4), this.check(16), this.check(56), this.check(156), this.check(172), this.check(1782), this.check(17782) );

    }
  }



}
